import { render, staticRenderFns } from "./DebtStatsType.vue?vue&type=template&id=ee44e97e&"
import script from "./DebtStatsType.vue?vue&type=script&lang=js&"
export * from "./DebtStatsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports